import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    html,textarea {
        font-family: 'Noto Sans KR', sans-serif;

    }
`;

export default GlobalStyle;
